import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY_STORAGE = 'chat_encryption_key';

export const setEncryptionKey = (key: string) => {
  sessionStorage.setItem(ENCRYPTION_KEY_STORAGE, key);
};

export const getEncryptionKey = (): string | null => {
  return sessionStorage.getItem(ENCRYPTION_KEY_STORAGE);
};

export const clearEncryptionKey = () => {
  sessionStorage.removeItem(ENCRYPTION_KEY_STORAGE);
};

export const encrypt = (text: string): string => {
  const key = getEncryptionKey();
  if (!key) {
    throw new Error('Ключ шифрования не установлен');
  }
  return CryptoJS.AES.encrypt(text, key).toString();
};

export const decrypt = (encryptedText: string): string => {
  const key = getEncryptionKey();
  if (!key) {
    throw new Error('Ключ шифрования не установлен');
  }
  const bytes = CryptoJS.AES.decrypt(encryptedText, key);
  return bytes.toString(CryptoJS.enc.Utf8);
};
